/**
 * A listing's condition (publicData.condition) as buyers read it, from en.json.
 * The values are the edit form's five condition cards.
 */
const CONDITION_MESSAGE_IDS = {
  new: 'ListingCondition.new',
  excellent: 'ListingCondition.excellent',
  good: 'ListingCondition.good',
  fair: 'ListingCondition.fair',
  poor: 'ListingCondition.poor',
};

/**
 * The condition's name, or null for a listing without one (or with a value the form doesn't
 * offer).
 *
 * @param {Object} intl
 * @param {String} condition e.g. 'excellent'
 * @return {String|null}
 */
export const conditionLabel = (intl, condition) => {
  const id = CONDITION_MESSAGE_IDS[condition];
  return id ? intl.formatMessage({ id }) : null;
};
